/**
 * Список доступных параметров для передачи в маректинговые событияе
 * @see app/common/enums/bi/EventVariableTypeEnum.php
 **/
export const MarketingEventVariableTypeEnum = {
    marketingProductId: 1,
    productType: 2,
    message: 3,
    productName: 4,
    productPrice: 5,
    currency: 6,
    productBrand: 7,
    productCategory: 8,
    quantity: 9,
    revenue: 10,
    items: 11,
    paymentType: 12,
    transactionId: 13,
    affiliation: 14,
    tax: 15,
    shipping: 16,
    value: 17,
    eventCategory: 18,
    eventLabel: 19,
    shippingTier: 20,
}

/**
 * TODO[justMvp]  - пока нет системы проверки внутренних параметров, добавлю для
 * item отдельный список парамтеров. Чтобы не хардконить в ручную сбор параметров.
 * и я бы убрал префикс item но пока для удобства коммункаци с менеджером оставлю.
 */
export const MarketingEventVariableItemTypeEnum = {
    itemId: 1,
  	itemName: 2,
  	price: 3,
    quantity: 4,
    itemBrand: 5,
    itemCategory: 6,
    itemVariant: 7,
}

/**
 * Вспомогательный объект который просто переворачивает ключи и значения местами
 * в MarketingEventVariableTypeEnum
 */
export const MarketingEventVariableNameById = Object.entries(MarketingEventVariableTypeEnum)
    .reduce((acc, [name, id]) => {
        acc[id] = name;
        return acc;
    }, {});